import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useState } from "react";

import { db } from "~/db/db";

const useEstados = () => {
  const [loading, setLoading] = useState(true);
  const [estados, setEstados] = useState([]);

  useEffect(() => {
    const fetchEstados = async () => {
      setLoading(true);
      const estadosResult = [];
      const query = db.estados;

      await query.each((estado) => estadosResult.push(estado));

      setEstados(estadosResult);
      setLoading(false);
    };

    fetchEstados();
  }, []);

  return {
    loading,
    estados
  }
}


export default useEstados;